module.exports = __webpack_public_path__ + "static/media/cfenc.6d935b2c.png";